import { Component, Input } from '@angular/core';
import { WinnerPost } from '@core/models/winner-post.model';

@Component({
  selector: 'app-post-card',
  templateUrl: './post-card.component.html',
  styleUrls: ['./post-card.component.scss']
})
export class PostCardComponent{
  @Input() type: 'winner' | 'draw-result' = 'draw-result';
  @Input() post: WinnerPost;

  constructor() { }

}
